import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgChatUrl from '@/assets/misc/img_chat.svg'
import WorkspaceIntercomIllustration from '@/components/SpotIllustration/WorkspaceIntercomIllustration'

export interface NotifyProsOfUnclaimedJobsDialogProps {
  showing: boolean
  onClose: () => void
  onNotifyPros: () => void
  isNotifyPending: boolean
}

export function NotifyProsOfUnclaimedJobsDialog({
  showing,
  onClose,
  onNotifyPros,
  isNotifyPending,
}: NotifyProsOfUnclaimedJobsDialogProps) {
  return (
    <ModalSheet
      onRequestClose={isNotifyPending ? undefined : onClose}
      showing={showing}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContentIllustration
        src={imgChatUrl}
        illustration={byDesign(undefined, WorkspaceIntercomIllustration)}
        alt="Illustration of a hand holding a phone and reading a message"
      />

      <ModalSheetContent>
        <ModalSheetContentTitle>
          Notify Pros of unclaimed jobs
        </ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Do you want to notify all available Pros of unclaimed jobs in this
          workspace?
        </ModalSheetContentDescription>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isNotifyPending}
            variant="default"
            onPress={onClose}
          />
          <Button
            label="Notify Pros"
            variant="primary"
            onPress={onNotifyPros}
            isPending={isNotifyPending}
            testId="notify-pros-of-unclaimed-jobs-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
